module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("32wOl"))).then(() => parcelRequire('37nVf'));